export default {
	// 应用名称
	APP_NAME: import.meta.env.VITE_APP_TITLE,
    //接口地址
    API_URL: import.meta.env.VITE_APP_ENV === 'development' ? "/api" : import.meta.env.VITE_API_BASE,
	// websocket
	WS_URL: import.meta.env.VITE_WS_URL,
	// 接口前缀
	API_PREFIX: '/admin/',
    //请求超时
    TIMEOUT: 10000,
    //请求是否开启缓存
    REQUEST_CACHE: false,
    //语言
    LANG: 'zh-cn',
	//主题风格 浅色：light | 深色：dark | 跟随系统：follow
	DARK: 'light',
    //TokenName
    TOKEN_NAME: "Authorization",
    //Token前缀，注意最后有个空格，如不需要需设置空字符串
    TOKEN_PREFIX: "Bearer ",
	//布局 分栏：column | 通栏：header | 经典：menu | 功能坞：dock
	//dock将关闭标签和面包屑栏
	APP_LAYOUT: 'column',
	// sm2公钥
	RSA_PUBLIC_KEY: import.meta.env.VITE_RSA_PUBLIC_KEY
}
